import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { DEFAULT_LOCALE } from './ProFormaIntlProvider';
var localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
export var getCodesFromLocale = function getCodesFromLocale(locale) {
  var match = localeRegex.exec(locale);
  if (!match) {
    // eslint-disable-next-line no-console
    console.error('Unable to get language and country from invalid locale, falling back to default locale.');
    match = localeRegex.exec(DEFAULT_LOCALE);
  }
  var _match = match,
    _match2 = _slicedToArray(_match, 3),
    language = _match2[1],
    country = _match2[2];
  return {
    language: language.toLowerCase(),
    country: country === null || country === void 0 ? void 0 : country.toUpperCase()
  };
};
var loadLazyI18nMessages = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale, lazyI18nMessages) {
    var _yield$default, _yield, _ref2;
    var _getCodesFromLocale, language, country;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _getCodesFromLocale = getCodesFromLocale(locale), language = _getCodesFromLocale.language, country = _getCodesFromLocale.country;
          _context.next = 3;
          return (_ref2 = country && lazyI18nMessages["".concat(language, "_").concat(country)] || lazyI18nMessages[language] || lazyI18nMessages.en) === null || _ref2 === void 0 ? void 0 : _ref2();
        case 3:
          _context.t2 = _yield = _context.sent;
          _context.t1 = _context.t2 === null;
          if (_context.t1) {
            _context.next = 7;
            break;
          }
          _context.t1 = _yield === void 0;
        case 7:
          if (!_context.t1) {
            _context.next = 11;
            break;
          }
          _context.t3 = void 0;
          _context.next = 12;
          break;
        case 11:
          _context.t3 = _yield.default;
        case 12:
          _context.t4 = _yield$default = _context.t3;
          _context.t0 = _context.t4 !== null;
          if (!_context.t0) {
            _context.next = 16;
            break;
          }
          _context.t0 = _yield$default !== void 0;
        case 16:
          if (!_context.t0) {
            _context.next = 20;
            break;
          }
          _context.t5 = _yield$default;
          _context.next = 21;
          break;
        case 20:
          _context.t5 = {};
        case 21:
          return _context.abrupt("return", _context.t5);
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadLazyI18nMessages(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var useLazyI18nMessages = function useLazyI18nMessages(locale, lazyI18nMessages) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    messages = _useState2[0],
    setMessages = _useState2[1];
  useEffect(function () {
    loadLazyI18nMessages(locale, lazyI18nMessages).catch(function () {
      return {};
    }).then(setMessages);
  }, [locale, setMessages, lazyI18nMessages]);
  return messages;
};